// Cedar WASM initialization module
import * as cedarWeb from '@cedar-policy/cedar-wasm/web';

// We need to manually initialize the WASM module in browser environments
let initialized = false;

export async function initCedar() {
    if (initialized) {
        return true; // Already initialized
    }

    try {
        console.log('Initializing Cedar WASM module...');

        // Try to fetch the WASM file from the public directory
        // This WASM file is manually copied from node_modules to public directory
        const response = await fetch('/cedar_wasm_bg.wasm');

        if (!response.ok) {
            throw new Error(`Failed to fetch WASM file: ${response.status} ${response.statusText}`);
        }

        // Get the WASM binary data
        const wasmBytes = await response.arrayBuffer();

        // Use the official initSync method to initialize the WASM module
        cedarWeb.initSync(wasmBytes);

        // Mark as initialized
        initialized = true;
        console.log('Cedar WASM module initialized successfully');
        return true;
    } catch (error) {
        console.error('Failed to initialize Cedar WASM:', error);
        return false;
    }
} 